import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["selectedValues", "name", "placeholder", "onChange", "options", "onBlur"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import "core-js/modules/es.function.name.js";
import React from "react";
import { Select, makeStyles, ListItemText, MenuItem, Checkbox, Chip, Typography, RaiseColors, Icon, IconConstants } from "componentLibrary";
import FieldBase from "componentLibrary/Fields/FieldBase";
import { OVERLAY_MENU_Z_INDEX } from "utils/constants";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    formControl: {},
    chips: {
      display: "flex",
      flexWrap: "wrap",
      gap: "8px"
    },
    multiSelect: {
      padding: 0
    }
  };
});
var MultiSelectField = function MultiSelectField(_ref) {
  var _context;
  var _ref$selectedValues = _ref.selectedValues,
    selectedValues = _ref$selectedValues === void 0 ? [] : _ref$selectedValues,
    name = _ref.name,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    options = _ref.options,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var multiselectClasses = {
    select: classes.multiSelect
  };
  var selectedOptions = _mapInstanceProperty(_context = _filterInstanceProperty(options).call(options, function (option) {
    return _includesInstanceProperty(selectedValues).call(selectedValues, option.value);
  })).call(_context, function (option) {
    return {
      label: option.label,
      value: option.value
    };
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FieldBase, _objectSpread(_objectSpread({
      fullWidth: true,
      InputLabelProps: {
        style: {
          position: "static"
        }
      }
    }, props), {}, {
      children: /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
        style: {
          height: "100%",
          textAlign: "left",
          marginBottom: 8
        },
        MenuProps: {
          disablePortal: false,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          },
          sx: {
            zIndex: OVERLAY_MENU_Z_INDEX
          },
          PaperProps: {
            onMouseDown: function onMouseDown(event) {
              event.preventDefault(); // Prevent dropdown from closing when selecting options
            }
          },
          keepMounted: true
        },
        IconComponent: function IconComponent(props) {
          return /*#__PURE__*/_jsx(Icon, {
            fontSize: 12,
            color: RaiseColors.midnightPurple,
            className: IconConstants.CHEVRON_DOWN,
            sx: {
              marginRight: 2
            }
          });
        },
        multiple: true,
        displayEmpty: true,
        value: selectedValues,
        name: name,
        onChange: onChange,
        onClose: onBlur,
        classes: _objectSpread({}, multiselectClasses),
        renderValue: function renderValue() {
          return /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph_small",
            color: RaiseColors.jllNeutral900,
            children: placeholder ? placeholder : "Select one or more"
          });
        } // Prevents select options from rendering in input
        ,
        notched: false
      }, props), {}, {
        children: _mapInstanceProperty(options).call(options, function (option) {
          return /*#__PURE__*/_jsxs(MenuItem, {
            value: option.value,
            children: [/*#__PURE__*/_jsx(Checkbox, {
              checked: _indexOfInstanceProperty(selectedValues).call(selectedValues, option.value) > -1,
              value: option.value,
              name: option.label
            }), /*#__PURE__*/_jsx(ListItemText, {
              primary: /*#__PURE__*/_jsx(Typography, {
                color: RaiseColors.black,
                children: option.label
              })
            })]
          }, option.value);
        })
      }))
    })), selectedOptions.length > 0 && /*#__PURE__*/_jsx("div", {
      className: classes.chips,
      children: _mapInstanceProperty(selectedOptions).call(selectedOptions, function (option, index) {
        return /*#__PURE__*/_jsx(Chip, {
          label: option.label,
          onDelete: function onDelete() {
            onChange({
              target: {
                name: name,
                value: _filterInstanceProperty(selectedValues).call(selectedValues, function (val) {
                  return val !== option.value;
                })
              }
            });
          }
        }, index);
      })
    })]
  });
};
export default MultiSelectField;